import React from 'react';

import MuiCheckbox, {
  CheckboxProps as MuiCheckboxProps,
} from '@mui/material/Checkbox';
import clsx from 'clsx';

import { CoreProps } from '../types';
import { withCoreProps } from '../withCoreProps';

export const Checkbox = withCoreProps<CheckboxProps>(
  ({ className, ...props }: React.PropsWithChildren<CheckboxProps>) => {
    const clsxClass = clsx(className);

    return <MuiCheckbox {...props} className={clsxClass} />;
  },
);

export interface CheckboxProps extends MuiCheckboxProps, CoreProps {}
